var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-panel c-panel--border c-panel--expand margin-b-24"},[(_vm.title)?_c('h3',{staticClass:"margin-b-8"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"fs-small"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }